module.exports = __webpack_public_path__ + "thumbnail-a4f87aeec2d7903c9c7e5bae05e813ca.png";